import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectDetail from "@/pages/ProjectDetail";
import DistressPage from "@/pages/DistressPage";
import AboutPage from "@/pages/AboutPage";
import BlogPage from "@/pages/BlogPage";
import BlogPost from "@/pages/BlogPost";
import ContactPage from "@/pages/ContactPage";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDeals from "@/pages/admin/AdminDeals";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminImport from "@/pages/admin/AdminImport";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminCrm from "@/pages/admin/AdminCrm";
import ListoneLanding from "@/pages/ListoneLanding";
import WadeemGardens from "@/pages/WadeemGardens";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/distress" element={<DistressPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/deals" element={<AdminDeals />} />
        <Route path="/admin/projects" element={<AdminProjects />} />
        <Route path="/admin/import" element={<AdminImport />} />
        <Route path="/admin/leads" element={<AdminLeads />} />
        <Route path="/admin/crm" element={<AdminCrm />} />
        <Route path="/listone" element={<ListoneLanding />} />
        <Route path="/wadeemgardens" element={<WadeemGardens />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
